function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Table_lamp"
}, /*#__PURE__*/React.createElement("title", null, "VF_table_lamp_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M155.8 255.2V127.6l127.6.2L219.5 0H64L0 127.3l127.7.2v127.7H56.9v28.2h169.7v-28.2h-70.8zM127.6 99.3l-81.8-.2 35.6-70.9H202l35.6 71.2-81.8-.2-28.2.1z"
}))));